import { selectConfigurators } from 'containers/configurators-listing/selectors';
import { useSelector } from 'react-redux';

export const useUnavailableServicesBanner = () => {
	const configrators = useSelector(selectConfigurators);

	const mainServicesIsVisible = !!configrators.length;

	const bannerTitle = mainServicesIsVisible
		? 'Услуга временно недоступна в вашем регионе'
		: 'Услуга недоступна в вашем регионе';

	const onClick = (e: React.MouseEvent<HTMLElement>) => {
		e.preventDefault();
		e.stopPropagation();

		const targetElement = document.getElementById('bestsellers');
		if (targetElement) {
			targetElement.scrollIntoView({ behavior: 'smooth' });
		}
	};

	return {
		mainServicesIsVisible,
		bannerTitle,
		onClick,
	};
};
